import { render, staticRenderFns } from "./AdvertItems.vue?vue&type=template&id=1c97a018&scoped=true&"
import script from "./AdvertItems.vue?vue&type=script&lang=js&"
export * from "./AdvertItems.vue?vue&type=script&lang=js&"
import style0 from "./AdvertItems.vue?vue&type=style&index=0&id=1c97a018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97a018",
  null
  
)

export default component.exports